import "./Plan.scss"
import React, { PropTypes } from "react"
import get from "lodash/get"
import numeral from "numeral"
import classnames from "classnames"
import { observer } from "mobx-react"
import { Icon } from "../../lib"
import { billingStore } from "../../app/stores"
import { FREE_PLAN } from "./subscription-plans"

const Plan = ({ plan }, { scrollTo }) => {
  const { id, name, price, interval, description } = plan
  const isSelected = id === billingStore.subscriptionPlan.id
  const isSelecting = id === get(billingStore, "selectingPlan.id")
  const className = classnames("Plan", {
    "Plan-selected": isSelected,
    "Plan-selecting": isSelecting,
  })

  function handleSelect() {
    if (isSelected) return
    billingStore.selectPlan(plan.id)
    if (plan.id === FREE_PLAN.id) {
      billingStore.confirmCancelSubscription()
    } else if (billingStore.subscribed) {
      billingStore.confirmUpdateSubscription()
    } else {
      setTimeout(() => scrollTo(500), 50)
    }
  }

  const [dollars, cents] = numeral(price / interval / 100)
    .format("0.00")
    .split(".")
  return (
    <div className={className} onClick={handleSelect}>
      <div className="Plan_info">
        <div className="Plan_price">
          $<h1>{dollars}</h1>
          <span>{cents}</span>
        </div>
        <span className="Plan_interval">
          {price === 0 ? (
            ""
          ) : interval === 12 ? (
            "per month, billed annually"
          ) : (
            "per month"
          )}
        </span>
        <label>{name}</label>

        <ul className="Plan_features">
          {description.map((feature, index) => <li key={index}>{feature}</li>)}
        </ul>
      </div>
      {isSelecting && billingStore.saving ? (
        <Icon name="refresh" size={24} spin />
      ) : isSelected ? (
        <Icon name="complete" size={24} />
      ) : null}
    </div>
  )
}

Plan.displayName = "Plan"

Plan.contextTypes = {
  scrollTo: PropTypes.func,
}

export default observer(Plan)



// WEBPACK FOOTER //
// ./src/account/billing/Plan.js